import type { CardTextProps } from '@/components/control/components/card-text/card-text.types';
import Control from '@/components/control';
import useChoice from '@/components/control/hooks/useChoice';
import { choiceId } from '@/components/control/utils';
import '@/components/control/components/card-text/card-text.css';

export default function CardText(props: CardTextProps) {
  const { type, onChange } = useChoice(props.value, props.id, props.onChange);

  return (
    <div className='control-card-text'>
      {props.choices.map((choice, index, choices) => {
        const id = choiceId(props.id, choice.value, index);
        return (
          <Control.RadioLabel
            key={id}
            id={id}
            value={props.value}
            state={props.state || 'idle'}
            choice={choice}
            choices={choices}
          >
            {({ focused, hovered, checked, state }) => (
              <Control.Box state={state} checked={checked} focused={focused}>
                <div className='control-card-text__label'>
                  <Control.HiddenInput
                    type={type}
                    id={id}
                    name={props.id}
                    value={choice.value}
                    checked={checked}
                    disabled={props.disabled}
                    onChange={(e, source) => onChange(choice.value, source)}
                  />
                  <div className='control-card-text__choice'>
                    <Control.Choice
                      type={type}
                      state={state}
                      checked={checked}
                      focused={focused}
                      hovered={hovered}
                      disabled={props.disabled}
                    />
                  </div>
                  <Control.RadioText size='lg' checked={checked}>
                    {choice.label}
                  </Control.RadioText>
                </div>
              </Control.Box>
            )}
          </Control.RadioLabel>
        );
      })}
    </div>
  );
}
